<template>
    <div class="card">
        <div class="bg-blue-light p-2">
            <TitleButton
                :showBtn="false"
                btnTitle="Add New"
                title="Receipt & Payment"
                :customCols="{ leftCol: 12, rightCol: 12 }"
            >
              <template #extra-btn>
                <div class="d-flex flex-wrap gap-75 mt-1 mt-md-0">
                  <button class="btn btn-primary btn-sm flex-grow-1 flex-md-grow-0" @click="goToDailySalesCollection">
                    <i class="fa fa-list"></i> Daily Sales Collection
                  </button>
                  <button v-if="headId" class="btn btn-success btn-sm flex-grow-1 flex-md-grow-0" @click="openReceiptModal">
                    <i class="fa fa-plus"></i> Receipt
                  </button>
                  <button v-if="headId" class="btn btn-danger btn-sm flex-grow-1 flex-md-grow-0" @click="openPaymentModal">
                    <i class="fa fa-minus"></i> Payment
                  </button>
                  <button v-if="headId" class="btn btn-secondary btn-sm flex-grow-1 flex-md-grow-0" @click="openContraModal">
                    <i class="fa fa-exchange-alt"></i> Transfer
                  </button>
                </div>
              </template>
            </TitleButton>
        </div>

        <div class="mx-2 mt-2 section-panel section-summary">
          <div class="filter-panel">
            <div class="row g-2 align-items-end">
              <div class="col-12 col-sm-6 col-md-3 col-lg-2">
                <label class="filter-label">From</label>
                <input
                    v-model="summaryStartDate"
                    type="date"
                    class="form-control date-mask"
                    placeholder="From"
                >
              </div>
              <div class="col-12 col-sm-6 col-md-3 col-lg-2">
                <label class="filter-label">To</label>
                <input
                    v-model="summaryEndDate"
                    type="date"
                    class="form-control date-mask"
                    placeholder="To"
                >
              </div>
              <div class="col-sm-2 col-md-2 d-flex align-items-end">
                <button
                    style="min-width: 64px;"
                    @click="getCashBankTotal"
                    class="btn btn-primary btn-block waves-effect waves-float waves-light"
                >
                  Go
                </button>
              </div>
            </div>
          </div>
          <div class="pt-1">
            <div v-if="showTotalSummary">
              <div class="subsection-title">All Cash &amp; Bank Total</div>
              <div class="row">
                <div class="col-6 col-md-4 col-fifth pd-5 py-1">
                  <div class="stat-card stat-opening min-height">
                    <div class="stat-card-info">
                      <div class="stat-card-label">Opening Balance</div>
                      <h4 class="stat-card-value">
                        {{ commaFormat(totalSummary.opening_balance) }}
                      </h4>
                    </div>
                    <span class="stat-card-icon">
                      <i class="fas fa-hourglass-start"></i>
                    </span>
                  </div>
                </div>
                <div class="col-6 col-md-4 col-fifth pd-5 py-1">
                  <div class="stat-card stat-debit min-height">
                    <div class="stat-card-info">
                      <div class="stat-card-label">Total Receipt</div>
                      <h4 class="stat-card-value">
                        {{ commaFormat(totalSummary.total_debit) }}
                      </h4>
                    </div>
                    <span class="stat-card-icon">
                      <i class="fas fa-arrow-down"></i>
                    </span>
                  </div>
                </div>
                <div class="col-6 col-md-4 col-fifth pd-5 py-1">
                  <div class="stat-card stat-credit min-height">
                    <div class="stat-card-info">
                      <div class="stat-card-label">Total Payment</div>
                      <h4 class="stat-card-value">
                        {{ commaFormat(totalSummary.total_credit) }}
                      </h4>
                    </div>
                    <span class="stat-card-icon">
                      <i class="fas fa-arrow-up"></i>
                    </span>
                  </div>
                </div>
                <div class="col-6 col-md-4 col-fifth pd-5 py-1">
                  <div class="stat-card stat-closing min-height">
                    <div class="stat-card-info">
                      <div class="stat-card-label">Closing Balance</div>
                      <h4 class="stat-card-value">
                        {{ commaFormat(totalSummary.closing_balance) }}
                      </h4>
                    </div>
                    <span class="stat-card-icon">
                      <i class="fas fa-hourglass-end"></i>
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="showTaxBalances">
              <div class="subsection-title">Tax Balances</div>
              <div class="row">
                <div class="col-6 col-md-4 col-fifth pd-5 py-1">
                  <div class="stat-card stat-opening min-height">
                    <div class="stat-card-info">
                      <div class="stat-card-label">Opening Balance</div>
                      <h4 class="stat-card-value">
                        {{ commaFormat(taxBalances.opening_balance) }}
                      </h4>
                    </div>
                    <span class="stat-card-icon">
                      <i class="fas fa-hourglass-start"></i>
                    </span>
                  </div>
                </div>
                <div class="col-6 col-md-4 col-fifth pd-5 py-1">
                  <div class="stat-card stat-credit min-height">
                    <div class="stat-card-info">
                      <div class="stat-card-label">(+) Sales Tax</div>
                      <h4 class="stat-card-value">
                        {{ commaFormat(taxBalances.sales_tax) }}
                      </h4>
                    </div>
                    <span class="stat-card-icon">
                      <i class="fas fa-circle-plus"></i>
                    </span>
                  </div>
                </div>
                <div class="col-6 col-md-4 col-fifth pd-5 py-1">
                  <div class="stat-card stat-closing min-height">
                    <div class="stat-card-info">
                      <div class="stat-card-label">(-) Purchase Tax</div>
                      <h4 class="stat-card-value">
                        {{ commaFormat(taxBalances.purchase_tax) }}
                      </h4>
                    </div>
                    <span class="stat-card-icon">
                      <i class="fas fa-circle-minus"></i>
                    </span>
                  </div>
                </div>
                <div class="col-6 col-md-4 col-fifth pd-5 py-1">
                  <div class="stat-card stat-closing min-height">
                    <div class="stat-card-info">
                      <div class="stat-card-label">(-) Tax Paid</div>
                      <h4 class="stat-card-value">
                        {{ commaFormat(taxBalances.tax_paid) }}
                      </h4>
                    </div>
                    <span class="stat-card-icon">
                      <i class="fas fa-receipt"></i>
                    </span>
                  </div>
                </div>
                <div class="col-6 col-md-4 col-fifth pd-5 py-1">
                  <div class="stat-card stat-debit min-height">
                    <div class="stat-card-info">
                      <div class="stat-card-label">Closing Balance</div>
                      <h4 class="stat-card-value">
                        {{ commaFormat(taxBalances.closing_balance) }}
                      </h4>
                    </div>
                    <span class="stat-card-icon">
                      <i class="fas fa-hourglass-end"></i>
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="!showTotalSummary && !showTaxBalances" class="empty-state">
              <i class="fas fa-wallet empty-state-icon"></i>
              <p class="mb-0">No summary data for the selected range</p>
            </div>
          </div>
        </div>

        <div class="mx-2 mt-3 section-panel section-ledger">
          <div class="filter-panel head-filter">
            <DateQuerySetter
                @onClickGo="getCustomerStatementData"
            >
              <div class="col-12 col-sm-6 col-md-4 col-lg-3">
                <label for="colFormLabel" class="filter-label">Account Head</label>
                <v-select
                    v-model="headId"
                    :options="accountHeads"
                    label="name"
                    placeholder="Select head"
                />
              </div>
            </DateQuerySetter>
          </div>

          <div class="mt-2">
            <div class="row" v-if="tableItems.length">
              <div class="col-6 col-md-4 col-fifth pd-5 py-1">
                <div class="stat-card stat-opening min-height">
                  <div class="stat-card-info">
                    <div class="stat-card-label">Opening Balance</div>
                    <h4 class="stat-card-value">
                      {{ commaFormat(ledgerData.opening_balance) }}
                    </h4>
                  </div>
                  <span class="stat-card-icon">
                    <i class="fas fa-hourglass-start"></i>
                  </span>
                </div>
              </div>
              <div class="col-6 col-md-4 col-fifth pd-5 py-1">
                <div class="stat-card stat-debit min-height">
                  <div class="stat-card-info">
                    <div class="stat-card-label">Total Receipt</div>
                    <h4 class="stat-card-value">
                      {{ commaFormat(ledgerData.total_debit) }}
                    </h4>
                  </div>
                  <span class="stat-card-icon">
                    <i class="fas fa-arrow-down"></i>
                  </span>
                </div>
              </div>
              <div class="col-6 col-md-4 col-fifth pd-5 py-1">
                <div class="stat-card stat-credit min-height">
                  <div class="stat-card-info">
                    <div class="stat-card-label">Total Payment</div>
                    <h4 class="stat-card-value">
                      {{ commaFormat(ledgerData.total_credit) }}
                    </h4>
                  </div>
                  <span class="stat-card-icon">
                    <i class="fas fa-arrow-up"></i>
                  </span>
                </div>
              </div>
              <div class="col-6 col-md-4 col-fifth pd-5 py-1">
                <div class="stat-card stat-closing min-height">
                  <div class="stat-card-info">
                    <div class="stat-card-label">Closing Balance</div>
                    <h4 class="stat-card-value">
                      {{ commaFormat(ledgerData.closing_balance) }}
                    </h4>
                  </div>
                  <span class="stat-card-icon">
                    <i class="fas fa-hourglass-end"></i>
                  </span>
                </div>
              </div>
            </div>
            <div class="table-section">
            <div class="col-12" v-if="tableItems.length">
              <div class="d-flex justify-content-end px-2">
                <button
                    @click="goToPrint"
                    class="btn btn-outline-secondary btn-sm btn-download-invoice waves-effect mx-1"
                >
                  Print
                </button>
                <button
                    @click="exportReport"
                    class="btn btn-outline-secondary btn-sm btn-download-invoice waves-effect"
                >
                  Export
                </button>
              </div>
            </div>

            <div class="table-responsive modern-table-wrap my-1" style="min-height: 200px">
              <table class="table modern-table table-sm-responsive">
                <thead>
                <tr>
                  <th>Date</th>
                  <th>Voucher Number</th>
                  <th>Account Head</th>
                  <th>Description</th>
                  <th>Party</th>
                  <th class="text-right">Receipts</th>
                  <th class="text-right">Payments</th>
                  <th class="text-right">Balance</th>
                  <th>Attachment</th>
                  <th class="text-center">Action</th>
                </tr>
                </thead>
                <tbody>
                <tr v-if="(currentPage === 1 || ((currentPage == undefined) && (currentPage === lastPage)))">
                  <td class="text-end" colspan="7"> Opening Balance </td>
                  <td class="text-end" colspan="1"> {{ commaFormat(ledgerData.opening_balance) }} </td>
                  <td colspan="2"></td>
                </tr>
                <tr v-for="(item ,index) in tableItems" :key="index">
                  <td>{{ item.formatted_date }} </td>
                  <td>{{ item.voucher_no }}</td>
                  <td>
                     <span>
                      <span v-if="isNullOrZero(item.debit)">
                          {{ getFirstAccountHead(item.debit_account_head || '') }}
                           <span v-if="isMultipleAccountHeads(item.debit_account_head)">
                             <button class="btn btn-outline-primary btn-sm"
                                     title="Print voucher"
                                     @click="goToPrintVoucher(item.ledger_master_id, item.voucher_type)"
                                     style="cursor: pointer;margin-left: 5px;margin-right: 5px;"
                             >
                               See Details
                            </button>
                          </span>
                      </span>
                       <span v-if="isNullOrZero(item.credit)">
                           {{ getFirstAccountHead(item.credit_account_head || '') }}
                           <span v-if="isMultipleAccountHeads(item.credit_account_head)">
                             <button class="btn btn-outline-primary btn-sm"
                                     title="Print voucher"
                                     @click="goToPrintVoucher(item.ledger_master_id, item.voucher_type)"
                                     style="cursor: pointer;margin-left: 5px;margin-right: 5px;"
                             >
                               See Details
                            </button>
                           </span>
                      </span>
                  </span>
                  </td>
                  <td>{{ item.line_description }}</td>
                  <td>{{ item.party_name }}</td>
                  <td class="text-right">{{ commaFormat(item.debit) }}</td>
                  <td class="text-right">{{ commaFormat(item.credit) }}</td>
                  <td class="text-right">{{ commaFormat(item.balance) }}</td>
                  <td>
                     <span v-if="item.attachments && item.attachments.length > 0" class="cursor-pointer">
                      <button
                          title="View attachment"
                          class="btn btn-outline-secondary btn-sm"
                          style="cursor: pointer"
                          @click="viewAttachments(item.attachments)"
                      >
                        <i class="fas fa-paperclip"></i>
                      </button>
                    </span>
                  </td>
                  <td class="text-center text-nowrap">
                    <div class="d-flex justify-content-center gap-75">
                      <button class="btn btn-outline-primary btn-sm"
                              title="Print voucher"
                              @click="goToPrintVoucher(item.ledger_master_id, item.voucher_type)"
                              style="cursor: pointer;"
                      >
                        <i class="fas fa-print"></i>
                      </button>

                      <button v-if="item.status == 'pending'" class="btn btn-primary btn-sm"
                              style="cursor: pointer"
                              @click="goToEdit(item.ledger_master_id, item.voucher_type)"
                      >
                        <i class="fas fa-eye"></i>
                      </button>
                    </div>
                  </td>
                </tr>
                <tr v-if="currentPage === lastPage">
                  <td class="text-end" colspan="5"> Closing Balance </td>
                  <td class="text-end"> {{ commaFormat(ledgerData.total_debit) }}</td>
                  <td class="text-end"> {{ commaFormat(ledgerData.total_credit) }}  </td>
                  <td class="text-end"> {{ commaFormat(ledgerData.closing_balance) }}</td>
                  <td colspan="2"></td>
                </tr>
                </tbody>
              </table>
              <div v-if="!tableItems.length" class="empty-state">
                <i class="fas fa-inbox empty-state-icon"></i>
                <p class="mb-0">No transactions found</p>
              </div>
            </div>
            </div>
          </div>

          <div class="px-2">
            <Pagination
                :offset="offset"
                @onPageChange="onPageChange"
                ref="pagination"
            />
          </div>
        </div>

      <ViewAttachment
          ref="viewAttachmentRef"
          :attachments="modalAttachments"
      />
      <ReceiptModal
          v-if="receiptModalShow"
          :headId="headId"
          @submit="getCustomerStatementData"
          @close="closeReceiptModal"
      />
      <PaymentModal
          v-if="paymentModalShow"
          :headId="headId"
          @submit="getCustomerStatementData"
          @close="closePaymentModal"
      />
      <ContraModal
          v-if="contraModalShow"
          :headId="headId"
          @submit="getCustomerStatementData"
          @close="closeContraModal"
      />
      <Loader v-if="loading"/>
    </div>
</template>

<script setup>
import {inject, onMounted, ref} from 'vue';
import {useRoute, useRouter} from 'vue-router'
import TitleButton from '@/components/atom/TitleButton'
import Loader from "@/components/atom/LoaderComponent.vue";
import handleReport from "@/services/modules/accountingReport";
import figureFormatter from '@/services/utils/figureFormatter'
import DateQuerySetter from '@/components/atom/DateQuerySetter'
import pdfPrinter from '@/services/utils/pdf/generalLedger';
import handleCompany from "@/services/modules/company";
import {useStore} from "vuex";
import Pagination from "@/components/atom/Pagination.vue";
import ViewAttachment from '@/views/page/company/ngo/voucher/payment/ViewAttachmentModal.vue'
import { useVoucherPrint } from '@/services/utils/voucherPrint';
import handlePayment from '@/services/modules/payment'
import ReceiptModal from '@/components/molecule/company/receipt-payment/ReceiptModal.vue';
import PaymentModal from '@/components/molecule/company/receipt-payment-global/PaymentModal.vue';
import ContraModal from '@/components/molecule/company/receipt-payment/ContraModal.vue';

const { fetchCompanyInfo } = handleCompany();
const { exportToPDF } = pdfPrinter();
const { fetchCashAndBank } = handlePayment()
const { getLedger, getHeadGroupSummary } = handleReport();
const route = useRoute()
const router = useRouter();
const store = useStore();
const showError = inject('showError');
let offset = ref(25)
const loading = ref(false);
const currentPage = ref(null);
const lastPage = ref(null);
const receiptModalShow = ref(false);
const paymentModalShow = ref(false);
const contraModalShow = ref(false);
const tableItems = ref([])
const ledgerData = ref({
  opening_balance: '0.00',
  total_debit: '0.00',
  total_credit: '0.00',
  closing_balance: '0.00',
})
const accountHeads = ref([])
const totalSummary = ref({
  opening_balance: '0.00',
  total_debit: '0.00',
  total_credit: '0.00',
  closing_balance: '0.00',
})
const showTotalSummary = ref(false)
const taxBalances = ref({
  opening_balance: '0.00',
  sales_tax: '0.00',
  purchase_tax: '0.00',
  tax_paid: '0.00',
  closing_balance: '0.00',
})
const showTaxBalances = ref(false)
const headId = ref(null)
const summaryStartDate = ref(route.query.start)
const summaryEndDate = ref(route.query.end)
const companyInfo = ref(null);
const modalAttachments = ref([]);
const viewAttachmentRef = ref();
const {commaFormat} = figureFormatter()

function getQuery () {
    let queryStr = '?company_id=' + route.params.companyId
    queryStr += '&offset=' + offset.value
    if (route.query.page) queryStr += "&page=" + route.query.page;
    if (route.query.start) queryStr += "&start_date=" + route.query.start;
    if (route.query.end) queryStr += "&end_date=" + route.query.end;
    if (headId.value) queryStr += '&headId=' + headId.value.id;
    return queryStr
}

function getSummaryQuery () {
    let queryStr = '?company_id=' + route.params.companyId
    queryStr += '&slag=cash_and_banks'
    if (summaryStartDate.value) queryStr += "&start_date=" + summaryStartDate.value;
    if (summaryEndDate.value) queryStr += "&end_date=" + summaryEndDate.value;
    return queryStr
}

function openReceiptModal() {
  receiptModalShow.value = true
}

function closeReceiptModal() {
  receiptModalShow.value = false
}

function openPaymentModal() {
  paymentModalShow.value = true
}

function closePaymentModal() {
  paymentModalShow.value = false
}

function openContraModal() {
  contraModalShow.value = true
}

function closeContraModal() {
  contraModalShow.value = false
}

const isNullOrZero = (value) => {
  return value == null || value === 0 || value === '0.00';
}

const isMultipleAccountHeads = (accountHead) => {
  return accountHead && accountHead.includes(',');
}

const viewAttachments = (attachments) => {
  modalAttachments.value = [];
  modalAttachments.value = attachments;
  viewAttachmentRef.value && viewAttachmentRef.value.toggleModal();
}

const { printVoucher, vouchers } = useVoucherPrint();
const goToPrintVoucher = (id, voucherType) => {
  printVoucher(id, voucherType)
}

const goToEdit = (id, type) => {
  const idParam = vouchers[type].idParams;
  const routeName = vouchers[type].route;
  router.push({
    name  : routeName,
    params: {
      companyId: route.params.companyId,
      moduleId : route.params.moduleId,
      menuId   : route.params.menuId,
      pageId   : route.params.pageId,
      [idParam]: id
    },
    query : {
      start: route.query.start,
      end: route.query.end,
      type: 'receipt-payment-global'
    }
  })
}

const getFirstAccountHead = (accountHead) => {
  return accountHead ? accountHead.split(',')[0] : '';
}

const goToDailySalesCollection = () => {
  router.push({
    name: 'daily-sales-collection',
    params: route.params,
    query: {
      ...route.query,
      redirect: 'receipt-payment-global'
    }
  })
}

const getAccountHeads = async () => {
  try {
    loading.value = true;
    let res = await fetchCashAndBank(route.params.companyId);
    if (!res.status) {
      showError(res.message);
    }
    accountHeads.value = res.data;
    headId.value = res.data[0]
  } catch (err) {
    showError("Something is wrong. Check your connectivity!!");
  } finally {
    loading.value = false;
  }
}

const getCustomerStatementData = async () => {
  if (!headId.value) {
    showError("Please select Head");
    return;
  }

  loading.value = true;
  try {
    const res = await getLedger({
      headId: headId.value.id,
      query: getQuery(),
    })

    if (!res.status) {
      tableItems.value = []
      return store.commit("resetPagination")
    }

    tableItems.value = res.data.ledgers.data;
    Object.assign(ledgerData.value, {
      opening_balance: res.data.opening_balance,
      closing_balance: res.data.closing_balance,
      total_debit: res.data.total_debit,
      total_credit: res.data.total_credit,
    })
    currentPage.value = res.data.ledgers.current_page
    lastPage.value = res.data.ledgers.last_page
    if (tableItems.value.length > 0) {
      setPagination(res.data.ledgers)
    }
  } catch (err) {
    if (err.response) {
      showError(err.response.message)
    }
  } finally {
    loading.value = false;
  }
}

const getCashBankTotal = async () => {
  loading.value = true;
  try {
    const res = await getHeadGroupSummary(getSummaryQuery())
    if (!res.status) {
      showTotalSummary.value = false
      showTaxBalances.value = false
      return
    }
    totalSummary.value = {
      opening_balance: res.data.opening_balance,
      total_debit: res.data.total_debit,
      total_credit: res.data.total_credit,
      closing_balance: res.data.closing_balance,
    }
    showTotalSummary.value = true
    if (!res.data.tax_balances) return
    taxBalances.value = res.data.tax_balances
    showTaxBalances.value = true
  } catch (err) {
    if (err.response) {
      showError(err.response.message)
    }
  } finally {
    loading.value = false;
  }
}

const setPaginationData = (data) => {
  store.commit('setPaginationData', data)
};

const onPageChange = async (page) => {
  let routeQuery = Object.assign({}, route.query)
  routeQuery.page = page
  await router.push({path: route.path, query: routeQuery})
  await getCustomerStatementData()
}

const setPagination = (data) => {
  setPaginationData({
    from: data.from,
    records: data.total,
    perPage: data.per_page,
    currentPage: data.current_page,
  })
}

const getCompany = async () => {
  await fetchCompanyInfo(route.params.companyId).then((res) => {
    companyInfo.value = res.data;
  })
}

const goToPrint = async() => {
  if (!headId.value) {
    showError("Please select Head");
    return;
  }

  let ledgerData = {};

  let query = getQuery();
  query += "&is_all=true";

  await getLedger({
    headId: headId.value.id,
    query: query,
  }).then((res) => {
    if (res.status){
      ledgerData = res.data;
      ledgerData.startDate = route.query.start;
      ledgerData.endDate = route.query.end;
      ledgerData.accountName = headId.value ? headId.value.name : ''
      exportToPDF(companyInfo.value, ledgerData, true)
    }
  })
}

onMounted(() => {
  getAccountHeads()
  getCompany();
  getCashBankTotal();
})

const exportReport = () => {
  if (!headId.value) {
    showError("Please select Head");
    return;
  }

  let token = localStorage.getItem('token');
  let url = `${process.env.VUE_APP_BASE_URL}/export/reports/general-ledger/${headId.value.id}${getQuery()}&_token=${token}`;
  let a = document.createElement('a');
  a.setAttribute('href', url);
  a.click();
}
</script>

<style scoped>
.min-height {
  min-height: 56px;
}
.font-bold {
  font-weight: bold;
}
.section-panel {
  border-radius: 14px;
  padding: 1rem 1rem 1.25rem;
  border: 1px solid transparent;
}
.section-summary {
  background: #f4f8ff;
  border-color: #e2ecfb;
}
.section-ledger {
  background: #f5faf6;
  border-color: #e0efe4;
}
.section-panel .filter-panel {
  background: #ffffff;
}
.section-ledger .table-section {
  background: #ffffff;
  margin: 0.75rem -1rem -1.25rem;
  padding: 1rem;
  border-bottom-left-radius: 14px;
  border-bottom-right-radius: 14px;
}
.filter-panel {
  background: #f8fafc;
  border: 1px solid #e9edf2;
  border-radius: 12px;
  padding: 0.9rem 1rem;
}
.filter-label {
  display: block;
  font-size: 0.72rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  color: #64748b;
  margin-bottom: 0.3rem;
  line-height: 1.2;
  min-height: 1.05rem;
}
.head-filter :deep(.row) {
  align-items: flex-end;
}
.head-filter :deep(.col-form-label) {
  display: block;
  font-size: 0.72rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  color: #64748b;
  padding: 0;
  margin-bottom: 0.3rem;
  line-height: 1.2;
  min-height: 1.05rem;
}
.head-filter :deep(.action-btn-setter) {
  margin-top: 0 !important;
  flex: 0 0 auto;
  width: auto;
  max-width: none;
}
.head-filter :deep(.action-btn-setter .btn) {
  min-width: auto !important;
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}
.subsection-title {
  font-size: 0.9rem;
  font-weight: 700;
  color: #334155;
  margin: 1rem 0 0.65rem;
  padding-bottom: 0.4rem;
  border-bottom: 1px solid #eef1f5;
}
.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  padding: 2.5rem 1rem;
  color: #94a3b8;
}
.empty-state-icon {
  font-size: 2rem;
  color: #cbd5e1;
}
@media (min-width: 768px) {
  .col-fifth {
    flex: 0 0 20%;
    max-width: 20%;
  }
}
.stat-card {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
  border: 1px solid #e5e7eb;
  border-radius: 9px;
  padding: 0.4rem 0.6rem;
  background: #fff;
  overflow: hidden;
  transition: box-shadow 0.15s ease, border-color 0.15s ease, transform 0.1s ease;
}
.stat-card:hover {
  box-shadow: 0 4px 14px rgba(15, 23, 42, 0.08);
  transform: translateY(-2px);
}
.stat-card-info {
  min-width: 0;
  flex: 1 1 auto;
}
.stat-card-icon {
  flex: 0 0 auto;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 8px;
  font-size: 0.85rem;
}
.stat-card-label {
  font-size: 0.62rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  color: #6b7280;
  margin-bottom: 0.1rem;
}
.stat-card-value {
  font-size: 1.1rem;
  font-weight: 700;
  color: #111827;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-bottom: 0;
}
@media (max-width: 576px) {
  .stat-card-value {
    font-size: 1rem;
  }
  .min-height {
    min-height: 52px;
  }
}
.card-head {
  h2 {
    font-weight: bold;
  }
}
.stat-opening {
  border-color: #a5edf7;
}
.stat-opening:hover {
  border-color: #06b6d4;
}
.stat-opening .stat-card-label {
  color: #0e7490;
}
.stat-opening .stat-card-icon {
  background: #d7f6fb;
  color: #0891b2;
}
.stat-debit {
  border-color: #d6c9fb;
}
.stat-debit:hover {
  border-color: #8b5cf6;
}
.stat-debit .stat-card-label {
  color: #6d28d9;
}
.stat-debit .stat-card-icon {
  background: #ece5fd;
  color: #7c3aed;
}
.stat-credit {
  border-color: #b6efc9;
}
.stat-credit:hover {
  border-color: #22c55e;
}
.stat-credit .stat-card-label {
  color: #15803d;
}
.stat-credit .stat-card-icon {
  background: #d9f7e3;
  color: #16a34a;
}
.stat-closing {
  border-color: #fbc9c9;
}
.stat-closing:hover {
  border-color: #ef4444;
}
.stat-closing .stat-card-label {
  color: #b91c1c;
}
.stat-closing .stat-card-icon {
  background: #fde0e0;
  color: #dc2626;
}
.modern-table-wrap {
  border: 1px solid #eef1f5;
  border-radius: 12px;
  overflow: hidden;
  background: #ffffff;
}
.modern-table {
  margin-bottom: 0;
}
.modern-table thead th {
  background: #f8fafc;
  color: #64748b;
  font-size: 0.72rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.02em;
  border: none;
  border-bottom: 1px solid #eef1f5;
  padding: 0.7rem 0.75rem;
  white-space: nowrap;
}
.modern-table tbody td {
  border: none;
  border-bottom: 1px solid #f1f4f8;
  padding: 0.65rem 0.75rem;
  vertical-align: middle;
  color: #334155;
}
.modern-table tbody tr:last-child td {
  border-bottom: none;
}
.modern-table tbody tr:hover td {
  background: #f8fbff;
}
@media (max-width: 576px) {
  .table-sm-responsive {
    font-size: 11px;
  }
  .table-sm-responsive th, .table-sm-responsive td {
    padding: 0.5rem 0.25rem !important;
  }
}
</style>
